import React from 'react';
import { View, Text } from 'react-native';
import { Controller } from 'react-hook-form';
import { useTheme } from '@react-navigation/native';
import CustomColorDots from '../CustomColorDots/CustomColorDots';

const CustomControlledColorDots = ({
    control,
    name,
    label,
    rules,
    options,
    defaultValue = null,
}) => {
    const { colors } = useTheme();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            defaultValue={defaultValue}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
                <View>
                    {label && <Text style={{ fontSize: 12, marginBottom: 6 }}>{label}</Text>}
                    <CustomColorDots value={value} onValueChange={onChange} options={options} />
                    {error && (
                        <Text style={{ color: colors.error, fontSize: 12, marginTop: 4 }}>
                            {error.message}
                        </Text>
                    )}
                </View>
            )}
        />
    );
};

export default CustomControlledColorDots;